import Image from "next/image";
import Link from "next/link";

export function ServiceCard({ icon, title, description, link }: any) {
  return (
    <div className="service-card">
      <Image
        src={icon}
        alt=""
        className="service-icon"
        width={50}
        height={50}
      />
      <div className="service-text">
        <div className="heading-03 cap">{title}</div>
        <div className="body-03 mt-20 op-60">{description}</div>
        <div className="mt-40">
          <div className="learn-more-wrap">
            <Link href={link} className="learn-more-link">
              <p className="sub-title-semibold">Learn More</p>
              <div className="underline _02"></div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
